const { queueAgentStates } = require('./states');

export const agentStatusColors = {
  [queueAgentStates.AVAILABLE]: '#17c46b',
  [queueAgentStates.RING]: '#e03623',
  [queueAgentStates.RINGING]: '#DB9513',
  [queueAgentStates.PAUSE]: '#2365e0',
  [queueAgentStates.UNPLACED]: '#8c8c8c'
};
